export default __webpack_public_path__ + "static/media/advertisers.fd55df9a.png";